export default "__VITE_ASSET__CZdpXzlZ__"